import React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CONSTANTS from "../util/constants";

import BootstrapTableComp from "./../component/TableComponent";
import "./../assets/css/nucleo-icons.css";
import "./../assets/css/soft-ui-dashboard.css";
import "./../assets/css/nucleo-svg.css";
import MovesComp from "../component/MovesComp";
import TrailersComp from "../component/TrailersComp";
import DivisionsComp from "../component/DivisionsComp";
import DoorsComp from "../component/DoorsComp";
import LotsComp from "../component/LotsComp";
import OffSiteLocaComp from "../component/OffSiteLocaComp";
import { useLocation, useNavigate } from "react-router-dom";
import TrailerManagementComp from "../component/TrailerManagementComp";
import UserManagementComp from "../component/UserManagementComp";
import { SpinnerCircular } from "spinners-react";
import OffSiteComp from "../component/OffSiteComp";
import CorrectionComp from "../component/CorrectionComp";
import DriversComp from "../component/DriversComp";
import DepartmentComp from "../component/DepartmentComp";
import Notification from "../component/Notification";
import TruckComp from "../component/TruckComp";
import encrypt from "../util/encrypt";

const Dashboard = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let location = useLocation();

  const [tableLoad, isTableLoadClick] = useState(false);
  const [moves, isMovesClick] = useState(false);
  const [correction, isCorrectionClick] = useState(false);
  const [divisions, isDivisionsClick] = useState(false);
  const [doors, isDoorsClick] = useState(false);
  const [lots, isLotsClick] = useState(false);
  const [offSiteLocations, isOffSiteLocationClick] = useState(false);
  const [truck, isTruckClick] = useState(false);
  const [userRole, isUserRolesClick] = useState(false);
  const [offSite, isOffSiteClick] = useState(false);
  const [trailers, isTrailersClick] = useState(false);
  const [ruralHallClick, isRuralHallClick] = useState(false);
  const [showSideBar, setShowSideBar] = useState(false);
  const [trailerManagementClick, isTrailerManagementCompClick] =
    useState(false);
  const [userManagementClick, isUserManagementClick] = useState(false);
  const [drivers, isDriversClick] = useState(false);
  const [department, isDepartmentClick] = useState(false);
  const [notificationClick, isNotificationClick] = useState(false);
  const [division, setDivision] = useState();
  const isLoading = useSelector((state) => state.login.isLoading);
  const [loginResponse, setLoginResponse] = useState(null);
  const userRoles = useSelector((state) => state.login.loginRolesData);
  const [notifactionCount, setNotificationCount] = useState(0);
  const notificationData = useSelector(
    (state) => state.notification.getNotificationResponse
  );

  useEffect(() => {
    let localstorageLR = localStorage.getItem("L_R");
    if (localstorageLR) {
      let data = localstorageLR ? encrypt.dycryptData(localstorageLR) : "";
      let loginResponse = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)
          : ""
        : "";
      setLoginResponse(loginResponse);
    } else {
      navigate("/", { replace: true });
    }
    dispatch({
      type: CONSTANTS.CONSTANTS_DRIVER_MANAGEMENT
        .GET_DRIVER_MANAGEMENT_API_CALL,
    });
  }, []);

  useEffect(() => {
    const setData = async () => {
      if (location?.search && location?.search.includes("?key=")) {
        if (location?.search) {
          let path = location?.search;
          let pathData = path.replace("?key=", "");
          await localStorage.setItem("L_R", pathData);
          dispatch({
            type: CONSTANTS.CONSTANTS_USER_MANAGEMENT
              .GET_USER_ROLES_MANAGEMENT_API_CALL,
          });
        }
      }

      if (location?.state && location?.state?.dc_selected != null) {
        setDivision(location?.state?.dc_selected?.divisionName);
        dispatch({
          type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.DIVISION_SELECTED,
          payload: {
            value: {
              label: location?.state?.dc_selected?.divisionName,
              value: location?.state?.dc_selected?.division_id,
            },
          },
        });
      }
    };

    setData();
  }, [location]);

  useEffect(() => {
    dispatch({
      type: CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.GET_TRUCK_MANAGEMENT_API_CALL,
    });
  }, []);

  useEffect(() => {
    if (notificationData && notificationData?.length > 0) {
      const readOnlyNotificationData = notificationData.filter(
        (data) => !data?.isRead
      );
      setNotificationCount(readOnlyNotificationData?.length);
    }
  }, [notificationData]);

  useEffect(() => {
    dispatch({
      type: CONSTANTS.CONSTANTS_NOTIFICATIONS_MANAGEMENT
        .GET_NOTIFICATIONS_API_CALL,
    });
  }, []);

  useEffect(() => {
    dispatch({
      type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT
        .GET_DIVISIONS_MANAGEMENT_API_CALL,
    });
  }, []);

  useEffect(() => {
    dispatch({
      type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_MANAGEMENT_API_CALL,
    });
  }, [doors]);

  useEffect(() => {
    dispatch({
      type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT
        .GET_DOORS_FOR_MOVE_MANAGEMENT_API_CALL,
    });
  }, []);

  useEffect(() => {
    dispatch({
      type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.GET_LOTS_MANAGEMENT_API_CALL,
    });
  }, [lots]);

  useEffect(() => {
    dispatch({
      type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
        .GET_LOTS_DIVISION_MANAGEMENT_API_CALL,
    });
  }, [correction]);

  useEffect(() => {
    if (
      loginResponse &&
      ((loginResponse?.user?.userRoles[0]?.user_role_name ==
        CONSTANTS.CONSTANTS_USER_ROLES.RHUSER &&
        loginResponse?.user?.userRoles[0]?.priority) ||
        (loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH &&
          loginResponse?.user?.userRoles[0]?.priority))
    ) {
      isTableLoadClick(false);
      isMovesClick(true);
    } else {
      isTableLoadClick(true);
    }
    dispatch({
      type: CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT
        .GET_TRAILER_MANAGEMENT_API_CALL,
    });
  }, [loginResponse]);

  return (
    <body
      className={
        showSideBar
          ? "g-sidenav-show bg-gray-100 g-sidenav-pinned"
          : "g-sidenav-show bg-gray-100"
      }
    >
      <div
        className="App-container container-fluid"
        style={{ backgroundColor: "#f8f9fa", overflowY: "scroll" }}
      >
        <SpinnerCircular enabled={false} />

        <div className="g-sidenav-show bg-gray-100">
          <aside
            className="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-3 bg-white"
            style={
              window.innerWidth < 1200
                ? { zIndex: 9999, overflowY: "scroll" }
                : { zIndex: 0, overflowY: "scroll" }
            }
            id="sidenav-main"
          >
            <div
              className="sidenav-header"
              style={{ backgroundColor: "#f8f9fa" }}
            >
              <i
                onClick={() => setShowSideBar(!showSideBar)}
                className={
                  window.innerWidth < 1200
                    ? "fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute end-0 top-0 "
                    : "fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute end-0 top-x d-none d-xl-none"
                }
                aria-hidden="true"
                id="iconSidenav"
              ></i>
              <a className="navbar-brand m-0" target="_blank">
                <img
                  src={require("./../assets/Dashboard/BurtonLogisticsLogo-DarkGray-small.png")}
                  className="navbar-brand-img"
                />
              </a>
            </div>

            <hr
              className="horizontal dark mt-0"
              style={{ backgroundColor: "darkGrey" }}
            />

            <div
              className={
                showSideBar && window.innerWidth < 1200
                  ? "collapse navbar-collapse  w-auto h-auto"
                  : "collapse navbar-collapse  w-auto h-auto"
              }
              id="sidenav-collapse-main"
              style={{ overflowY: "scroll" }}
            >
              <div
                style={{ cursor: "pointer" }}
                className={
                  window.innerWidth < 1200
                    ? "nav-item mobileMenu"
                    : "nav-item d-flex f-direction-row m-2 align-items-center"
                }
                onClick={() => {
                  if (
                    loginResponse &&
                    ((loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
                      loginResponse?.user?.userRoles[0]?.priority) ||
                      (loginResponse?.user?.userRoles[0]?.user_role_name ==
                        CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                        loginResponse?.user?.userRoles[0]?.priority) ||
                      (loginResponse?.user?.userRoles[0]?.user_role_name ==
                        CONSTANTS.CONSTANTS_USER_ROLES.VIEWONLY &&
                        loginResponse?.user?.userRoles[0]?.priority))
                  ) {
                    ruralHallClick
                      ? isRuralHallClick(false)
                      : isRuralHallClick(true);
                    isTableLoadClick(true);
                    isMovesClick(false);
                    isCorrectionClick(false);
                    isTrailersClick(false);
                    isDivisionsClick(false);
                    isDoorsClick(false);
                    isLotsClick(false);
                    isOffSiteClick(false);
                    isOffSiteLocationClick(false);
                    isTrailerManagementCompClick(false);
                    isUserManagementClick(false);
                    isDriversClick(false);
                    isDepartmentClick(false);
                    isTruckClick(false);
                    isUserRolesClick(false);
                  } else {
                    isTableLoadClick(false);
                    ruralHallClick
                      ? isRuralHallClick(false)
                      : isRuralHallClick(true);
                    isMovesClick(true);
                    isCorrectionClick(false);
                    isTrailersClick(false);
                    isDivisionsClick(false);
                    isDoorsClick(false);
                    isLotsClick(false);
                    isOffSiteClick(false);
                    isOffSiteLocationClick(false);
                    isTrailerManagementCompClick(false);
                    isUserManagementClick(false);
                    isDriversClick(false);
                    isDepartmentClick(false);
                    isTruckClick(false);
                    isUserRolesClick(false);
                  }
                }}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-1 ms-2 d-flex align-items-center justify-content-center">
                  <img
                    src={require("./../assets/Dashboard/ruralHall.png")}
                  ></img>
                </div>

                <h6
                  className="nav-link-text ms-2 me-4  text-uppercase text-sm opacity-7 mt-2"
                  style={{
                    color: "black",
                    fontWeight: ruralHallClick ? "bold" : "normal",
                  }}
                >
                  Rural Hall {division} DC
                </h6>

                <div className="icon icon-shape icon-l  border-radius-md bg-white text-center me-1 mt-1 d-flex align-items-center justify-content-center">
                  <img src={require("./../assets/Dashboard/chevron.png")}></img>
                </div>
              </div>

              {ruralHallClick || window.innerWidth < 1200 ? (
                <ul className="navbar-nav">
                  {loginResponse &&
                  ((loginResponse?.user?.userRoles[0]?.user_role_name ==
                    CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
                    loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                      loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.VIEWONLY &&
                      loginResponse?.user?.userRoles[0]?.priority)) ? (
                    <li className="nav-item">
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          isTableLoadClick(true);
                          isMovesClick(false);
                          isCorrectionClick(false);
                          isTrailersClick(false);
                          isDivisionsClick(false);
                          isDoorsClick(false);
                          isLotsClick(false);
                          isOffSiteClick(false);
                          isOffSiteLocationClick(false);
                          isTrailerManagementCompClick(false);
                          isUserManagementClick(false);
                          isDriversClick(false);
                          isDepartmentClick(false);
                          isTruckClick(false);
                          isUserRolesClick(false);
                          if (window.innerWidth < 1200) {
                            setShowSideBar(!showSideBar);
                          }
                        }}
                        className={
                          tableLoad ? "nav-link active" : "nav-link  inactive"
                        }
                      >
                        <div className="icon icon-shape icon-sm  border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                          {tableLoad ? (
                            <img
                              src={require("./../assets/Dashboard/dashboardWhite.png")}
                            ></img>
                          ) : (
                            <img
                              src={require("./../assets/Dashboard/dashboard.png")}
                            ></img>
                          )}
                          <title>Reports and Yard check</title>
                        </div>
                        <span className="nav-link-text ">
                          Reports and Yard check
                        </span>
                      </div>
                    </li>
                  ) : null}
                  <li className="nav-item">
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        isTableLoadClick(false);
                        isMovesClick(true);
                        isTrailersClick(false);
                        isCorrectionClick(false);
                        isDivisionsClick(false);
                        isDoorsClick(false);
                        isLotsClick(false);
                        isOffSiteClick(false);
                        isOffSiteLocationClick(false);
                        isTrailerManagementCompClick(false);
                        isUserManagementClick(false);
                        isDriversClick(false);
                        isDepartmentClick(false);
                        isTruckClick(false);
                        isUserRolesClick(false);
                        if (window.innerWidth < 1200) {
                          setShowSideBar(!showSideBar);
                        }
                      }}
                      className={
                        moves ? "nav-link active" : "nav-link inactive"
                      }
                    >
                      <div className="icon icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                        {moves ? (
                          <img
                            src={require("./../assets/Dashboard/dashboardWhite.png")}
                          ></img>
                        ) : (
                          <img
                            src={require("./../assets/Dashboard/dashboard.png")}
                          ></img>
                        )}
                        <title>Yard Moves</title>
                      </div>
                      <span className="nav-link-text ms-1">Yard Moves</span>
                    </div>
                  </li>
                  <li className="nav-item">
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        isTableLoadClick(false);
                        isMovesClick(false);
                        isCorrectionClick(false);
                        isDivisionsClick(false);
                        isDoorsClick(false);
                        isLotsClick(false);
                        isOffSiteClick(true);
                        isDepartmentClick(false);
                        isOffSiteLocationClick(false);
                        isTrailersClick(false);
                        isTrailerManagementCompClick(false);
                        isUserManagementClick(false);
                        isDriversClick(false);
                        isTruckClick(false);
                        isUserRolesClick(false);
                        if (window.innerWidth < 1200) {
                          setShowSideBar(!showSideBar);
                        }
                      }}
                      className={
                        offSite ? "nav-link active" : "nav-link inactive"
                      }
                    >
                      <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                        {offSite ? (
                          <img
                            src={require("./../assets/Dashboard/dashboardWhite.png")}
                          ></img>
                        ) : (
                          <img
                            src={require("./../assets/Dashboard/dashboard.png")}
                          ></img>
                        )}
                        <title>Offsite Moves</title>
                      </div>
                      <span className="nav-link-text ms-1">Offsite Moves</span>
                    </div>
                  </li>

                  {loginResponse &&
                  ((loginResponse?.user?.userRoles[0]?.user_role_name ==
                    CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
                    loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                      loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.VIEWONLY &&
                      loginResponse?.user?.userRoles[0]?.priority)) ? (
                    <li className="nav-item">
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          isTableLoadClick(false);
                          isMovesClick(false);
                          isCorrectionClick(false);
                          isTrailersClick(false);
                          isDivisionsClick(false);
                          isDoorsClick(false);
                          isLotsClick(false);
                          isOffSiteClick(false);
                          isOffSiteLocationClick(false);
                          isTrailerManagementCompClick(false);
                          isUserManagementClick(false);
                          isDriversClick(false);
                          isDepartmentClick(true);
                          isTruckClick(false);
                          isUserRolesClick(false);
                          if (window.innerWidth < 1200) {
                            setShowSideBar(!showSideBar);
                          }
                        }}
                        className={
                          department ? "nav-link active" : "nav-link inactive"
                        }
                      >
                        <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                          {department ? (
                            <img
                              src={require("./../assets/Dashboard/dashboardWhite.png")}
                            ></img>
                          ) : (
                            <img
                              src={require("./../assets/Dashboard/dashboard.png")}
                            ></img>
                          )}
                          <title>Department</title>
                        </div>
                        <span className="nav-link-text ms-1">Department</span>
                      </div>
                    </li>
                  ) : null}

                  {loginResponse &&
                  ((loginResponse?.user?.userRoles[0]?.user_role_name ==
                    CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
                    loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                      loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH &&
                      loginResponse?.user?.userRoles[0]?.priority)) ? (
                    <li className="nav-item">
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          isTableLoadClick(false);
                          isMovesClick(false);
                          isCorrectionClick(true);
                          isTrailersClick(false);
                          isDivisionsClick(false);
                          isDoorsClick(false);
                          isLotsClick(false);
                          isOffSiteClick(false);
                          isOffSiteLocationClick(false);
                          isTrailerManagementCompClick(false);
                          isUserManagementClick(false);
                          isDriversClick(false);
                          isDepartmentClick(false);
                          isTruckClick(false);
                          isUserRolesClick(false);
                          if (window.innerWidth < 1200) {
                            setShowSideBar(!showSideBar);
                          }
                        }}
                        className={
                          correction ? "nav-link active" : "nav-link inactive"
                        }
                      >
                        <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                          {correction ? (
                            <img
                              src={require("./../assets/Dashboard/dashboardWhite.png")}
                            ></img>
                          ) : (
                            <img
                              src={require("./../assets/Dashboard/dashboard.png")}
                            ></img>
                          )}
                          <title>Correction </title>
                        </div>
                        <span className="nav-link-text ms-1">Correction</span>
                      </div>
                    </li>
                  ) : null}

                  {loginResponse &&
                  ((loginResponse?.user?.userRoles[0]?.user_role_name ==
                    CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
                    loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                      loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.VIEWONLY &&
                      loginResponse?.user?.userRoles[0]?.priority)) ? (
                    <li className="nav-item">
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          isTableLoadClick(false);
                          isMovesClick(false);
                          isCorrectionClick(false);
                          isDivisionsClick(true);
                          isDoorsClick(false);
                          isLotsClick(false);
                          isOffSiteClick(false);
                          isOffSiteLocationClick(false);
                          isTrailersClick(false);
                          isTrailerManagementCompClick(false);
                          isUserManagementClick(false);
                          isDriversClick(false);
                          isDepartmentClick(false);
                          isTruckClick(false);
                          isUserRolesClick(false);
                          if (window.innerWidth < 1200) {
                            setShowSideBar(!showSideBar);
                          }
                        }}
                        className={
                          divisions ? "nav-link active" : "nav-link inactive"
                        }
                      >
                        <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                          {divisions ? (
                            <img
                              src={require("./../assets/Dashboard/dashboardWhite.png")}
                            ></img>
                          ) : (
                            <img
                              src={require("./../assets/Dashboard/dashboard.png")}
                            ></img>
                          )}
                          <title>Divisions </title>
                        </div>
                        <span className="nav-link-text ms-1">Divisions</span>
                      </div>
                    </li>
                  ) : null}

                  {loginResponse &&
                  ((loginResponse?.user?.userRoles[0]?.user_role_name ==
                    CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
                    loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                      loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.VIEWONLY &&
                      loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH &&
                      loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.RHUSER &&
                      loginResponse?.user?.userRoles[0]?.priority)) ? (
                    <li className="nav-item">
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          isTableLoadClick(false);
                          isMovesClick(false);
                          isCorrectionClick(false);
                          isDivisionsClick(false);
                          isDoorsClick(true);
                          isLotsClick(false);
                          isOffSiteClick(false);
                          isOffSiteLocationClick(false);
                          isTrailersClick(false);
                          isTrailerManagementCompClick(false);
                          isUserManagementClick(false);
                          isDriversClick(false);
                          isDepartmentClick(false);
                          isTruckClick(false);
                          isUserRolesClick(false);
                          if (window.innerWidth < 1200) {
                            setShowSideBar(!showSideBar);
                          }
                        }}
                        className={
                          doors ? "nav-link active" : "nav-link inactive"
                        }
                      >
                        <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                          {doors ? (
                            <img
                              src={require("./../assets/Dashboard/dashboardWhite.png")}
                            ></img>
                          ) : (
                            <img
                              src={require("./../assets/Dashboard/dashboard.png")}
                            ></img>
                          )}
                          <title>{"Doors"} </title>
                        </div>
                        <span className="nav-link-text ms-1">{"Doors"}</span>
                      </div>
                    </li>
                  ) : null}
                  {loginResponse &&
                  ((loginResponse?.user?.userRoles[0]?.user_role_name ==
                    CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
                    loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                      loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.VIEWONLY &&
                      loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH &&
                      loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.RHUSER &&
                      loginResponse?.user?.userRoles[0]?.priority)) ? (
                    <li className="nav-item">
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          isTableLoadClick(false);
                          isMovesClick(false);
                          isCorrectionClick(false);
                          isDivisionsClick(false);
                          isDoorsClick(false);
                          isLotsClick(true);
                          isOffSiteClick(false);
                          isOffSiteLocationClick(false);
                          isTrailersClick(false);
                          isTrailerManagementCompClick(false);
                          isUserManagementClick(false);
                          isDriversClick(false);
                          isDepartmentClick(false);
                          isTruckClick(false);
                          isUserRolesClick(false);
                          if (window.innerWidth < 1200) {
                            setShowSideBar(!showSideBar);
                          }
                        }}
                        className={
                          lots ? "nav-link active" : "nav-link inactive"
                        }
                      >
                        <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                          {lots ? (
                            <img
                              src={require("./../assets/Dashboard/dashboardWhite.png")}
                            ></img>
                          ) : (
                            <img
                              src={require("./../assets/Dashboard/dashboard.png")}
                            ></img>
                          )}
                          <title>Lots </title>
                        </div>
                        <span className="nav-link-text ms-1">Yard</span>
                      </div>
                    </li>
                  ) : null}

                  {loginResponse &&
                  ((loginResponse?.user?.userRoles[0]?.user_role_name ==
                    CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
                    loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                      loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.VIEWONLY &&
                      loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH &&
                      loginResponse?.user?.userRoles[0]?.priority)) ? (
                    <li className="nav-item">
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          isTableLoadClick(false);
                          isMovesClick(false);
                          isCorrectionClick(false);
                          isDivisionsClick(false);
                          isDoorsClick(false);
                          isLotsClick(false);
                          isOffSiteClick(false);
                          isOffSiteLocationClick(false);
                          isTrailersClick(false);
                          isTrailerManagementCompClick(false);
                          isUserManagementClick(false);
                          isDriversClick(false);
                          isDepartmentClick(false);
                          isTruckClick(true);
                          isUserRolesClick(false);
                          isNotificationClick(false);
                          if (window.innerWidth < 1200) {
                            setShowSideBar(!showSideBar);
                          }
                        }}
                        className={
                          truck ? "nav-link active" : "nav-link inactive"
                        }
                      >
                        <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                          {truck ? (
                            <img
                              src={require("./../assets/Dashboard/dashboardWhite.png")}
                            ></img>
                          ) : (
                            <img
                              src={require("./../assets/Dashboard/dashboard.png")}
                            ></img>
                          )}
                          <title> Trucks </title>
                        </div>
                        <span className="nav-link-text ms-1"> Trucks </span>
                      </div>
                    </li>
                  ) : null}

                  {loginResponse &&
                  ((loginResponse?.user?.userRoles[0]?.user_role_name ==
                    CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
                    loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                      loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.VIEWONLY &&
                      loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH &&
                      loginResponse?.user?.userRoles[0]?.priority)) ? (
                    <li className="nav-item">
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          isTableLoadClick(false);
                          isMovesClick(false);
                          isCorrectionClick(false);
                          isDivisionsClick(false);
                          isDoorsClick(false);
                          isLotsClick(false);
                          isOffSiteClick(false);
                          isOffSiteLocationClick(true);
                          isTrailersClick(false);
                          isTrailerManagementCompClick(false);
                          isUserManagementClick(false);
                          isDriversClick(false);
                          isDepartmentClick(false);
                          isTruckClick(false);
                          isUserRolesClick(false);
                          if (window.innerWidth < 1200) {
                            setShowSideBar(!showSideBar);
                          }
                        }}
                        className={
                          offSiteLocations
                            ? "nav-link active"
                            : "nav-link inactive"
                        }
                      >
                        <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                          {offSiteLocations ? (
                            <img
                              src={require("./../assets/Dashboard/dashboardWhite.png")}
                            ></img>
                          ) : (
                            <img
                              src={require("./../assets/Dashboard/dashboard.png")}
                            ></img>
                          )}
                          <title>Off Site Locations </title>
                        </div>
                        <span className="nav-link-text ms-1">
                          Off Site Locations
                        </span>
                      </div>
                    </li>
                  ) : null}
                  {/* //Drives */}
                  {loginResponse &&
                  ((loginResponse?.user?.userRoles[0]?.user_role_name ==
                    CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
                    loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                      loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.VIEWONLY &&
                      loginResponse?.user?.userRoles[0]?.priority) ||
                    (loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH &&
                      loginResponse?.user?.userRoles[0]?.priority)) ? (
                    <li className="nav-item">
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          isTableLoadClick(false);
                          isMovesClick(false);
                          isCorrectionClick(false);
                          isDivisionsClick(false);
                          isDoorsClick(false);
                          isLotsClick(false);
                          isOffSiteClick(false);
                          isOffSiteLocationClick(false);
                          isTrailersClick(false);
                          isTrailerManagementCompClick(false);
                          isUserManagementClick(false);
                          isDriversClick(true);
                          isDepartmentClick(false);
                          isTruckClick(false);
                          isUserRolesClick(false);
                          if (window.innerWidth < 1200) {
                            setShowSideBar(!showSideBar);
                          }
                        }}
                        className={
                          drivers ? "nav-link active" : "nav-link inactive"
                        }
                      >
                        <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                          {drivers ? (
                            <img
                              src={require("./../assets/Dashboard/dashboardWhite.png")}
                            ></img>
                          ) : (
                            <img
                              src={require("./../assets/Dashboard/dashboard.png")}
                            ></img>
                          )}
                          <title>Drivers</title>
                        </div>
                        <span className="nav-link-text ms-1">Drivers</span>
                      </div>
                    </li>
                  ) : null}

                  {/* //Drivers */}

                  <li className="nav-item">
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        isTableLoadClick(false);
                        isMovesClick(false);
                        isCorrectionClick(false);
                        isDivisionsClick(false);
                        isDoorsClick(false);
                        isLotsClick(false);
                        isOffSiteClick(false);
                        isOffSiteLocationClick(false);
                        isTrailersClick(true);
                        isTrailerManagementCompClick(false);
                        isUserManagementClick(false);
                        isDriversClick(false);
                        isDepartmentClick(false);
                        isTruckClick(false);
                        isUserRolesClick(false);
                        if (window.innerWidth < 1200) {
                          setShowSideBar(!showSideBar);
                        }
                      }}
                      className={
                        trailers ? "nav-link active" : "nav-link inactive"
                      }
                    >
                      <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                        {trailers ? (
                          <img
                            src={require("./../assets/Dashboard/dashboardWhite.png")}
                          ></img>
                        ) : (
                          <img
                            src={require("./../assets/Dashboard/dashboard.png")}
                          ></img>
                        )}
                        <title>Trailers anuj</title>
                      </div>
                      <span className="nav-link-text ms-1">
                        Trailer Inventory
                      </span>
                    </div>
                  </li>

                  {window.innerWidth < 1200 ? (
                    loginResponse &&
                    ((loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
                      loginResponse?.user?.userRoles[0]?.priority) ||
                      (loginResponse?.user?.userRoles[0]?.user_role_name ==
                        CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                        loginResponse?.user?.userRoles[0]?.priority) ||
                      (loginResponse?.user?.userRoles[0]?.user_role_name ==
                        CONSTANTS.CONSTANTS_USER_ROLES.VIEWONLY &&
                        loginResponse?.user?.userRoles[0]?.priority)) ? (
                      <li className="nav-item">
                        <div
                          onClick={() => {
                            isTableLoadClick(false);
                            isMovesClick(false);
                            isCorrectionClick(false);
                            isTrailersClick(false);
                            isDivisionsClick(false);
                            isDoorsClick(false);
                            isLotsClick(false);
                            isOffSiteClick(false);
                            isOffSiteLocationClick(false);
                            isTrailerManagementCompClick(false);
                            isUserManagementClick(true);
                            isRuralHallClick(false);
                            isDriversClick(false);
                            isDepartmentClick(false);
                            isTruckClick(false);
                            isUserRolesClick(false);
                            setShowSideBar(!showSideBar);
                          }}
                          style={{ cursor: "pointer" }}
                          className={
                            userManagementClick
                              ? "nav-link active"
                              : "nav-link inactive"
                          }
                        >
                          <div className="icon icon-shape icon-lg shadow border-radius-md bg-white  me-2 d-flex align-items-center justify-content-center">
                            <img
                              src={require("./../assets/Dashboard/userManagement.png")}
                            ></img>

                            <title>{"User Management"} </title>
                          </div>
                          <span className="nav-link-text ms-1">
                            User Management
                          </span>
                        </div>
                      </li>
                    ) : null
                  ) : null}

                  {window.innerWidth < 1200 ? (
                    loginResponse &&
                    ((loginResponse?.user?.userRoles[0]?.user_role_name ==
                      CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
                      loginResponse?.user?.userRoles[0]?.priority) ||
                      (loginResponse?.user?.userRoles[0]?.user_role_name ==
                        CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                        loginResponse?.user?.userRoles[0]?.priority) ||
                      (loginResponse?.user?.userRoles[0]?.user_role_name ==
                        CONSTANTS.CONSTANTS_USER_ROLES.VIEWONLY &&
                        loginResponse?.user?.userRoles[0]?.priority)) ? (
                      <li className="nav-item">
                        <div
                          onClick={() => {
                            isTableLoadClick(false);
                            isMovesClick(false);
                            isCorrectionClick(false);
                            isTrailersClick(false);
                            isDivisionsClick(false);
                            isDoorsClick(false);
                            isLotsClick(false);
                            isOffSiteClick(false);
                            isOffSiteLocationClick(false);
                            isTrailerManagementCompClick(true);
                            isUserManagementClick(false);
                            isRuralHallClick(false);
                            isDriversClick(false);
                            isDepartmentClick(false);
                            isTruckClick(false);
                            isUserRolesClick(false);
                            setShowSideBar(!showSideBar);
                          }}
                          style={{ cursor: "pointer" }}
                          className={
                            trailerManagementClick
                              ? "nav-link active"
                              : "nav-link inactive"
                          }
                        >
                          <div className="icon icon-shape icon-lg shadow border-radius-md bg-white  me-2 d-flex align-items-center justify-content-center">
                            <img
                              src={require("./../assets/Dashboard/truck.png")}
                              style={{ width: 16, height: 16 }}
                            ></img>

                            <title>{"Trailer Management"} </title>
                          </div>
                          <span className="nav-link-text ms-1">
                            Trailer Management
                          </span>
                        </div>
                      </li>
                    ) : null
                  ) : null}

                  {window.innerWidth < 1200 ? (
                    <li className="nav-item">
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          localStorage.clear();
                          dispatch({
                            type: CONSTANTS.CONSTANTS_LOGIN.USER_LOGOUT,
                          });
                          navigate("/");
                        }}
                        className={"nav-link inactive"}
                      >
                        <div className="icon icon-shape icon-lg shadow border-radius-md bg-white  me-2 d-flex align-items-center justify-content-center">
                          <img
                            src={require("./../assets/Dashboard/logout1.png")}
                            style={{ width: 16, height: 16 }}
                          ></img>

                          <title>LogOut </title>
                        </div>
                        <span className="nav-link-text ms-1">LogOut</span>
                      </div>
                    </li>
                  ) : null}
                </ul>
              ) : null}

              {/* //"user_role_id": 4 : userRoles[3] */}

              {loginResponse &&
              ((loginResponse?.user?.userRoles[0]?.user_role_name ==
                CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
                loginResponse?.user?.userRoles[0]?.priority) ||
                (loginResponse?.user?.userRoles[0]?.user_role_name ==
                  CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                  loginResponse?.user?.userRoles[0]?.priority) ||
                (loginResponse?.user?.userRoles[0]?.user_role_name ==
                  CONSTANTS.CONSTANTS_USER_ROLES.VIEWONLY &&
                  loginResponse?.user?.userRoles[0]?.priority)) ? (
                <div
                  className={
                    window.innerWidth < 1200
                      ? "nav-item mt-3 mobileMenu"
                      : "d-flex f-direction-row m-2 align-items-center mt-3 "
                  }
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    isTableLoadClick(false);
                    isMovesClick(false);
                    isTrailersClick(false);
                    isCorrectionClick(false);
                    isDivisionsClick(false);
                    isDoorsClick(false);
                    isLotsClick(false);
                    isOffSiteClick(false);
                    isOffSiteLocationClick(false);
                    isTrailerManagementCompClick(false);
                    isUserManagementClick(true);
                    isRuralHallClick(false);
                    isDriversClick(false);
                    isDepartmentClick(false);
                    setShowSideBar(!showSideBar);
                  }}
                >
                  <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-1 ms-2 d-flex align-items-center justify-content-center">
                    <img
                      src={require("./../assets/Dashboard/userManagement.png")}
                    ></img>
                  </div>
                  <h6
                    className="nav-link-text ms-2 me-4 mt-2 text-uppercase text-sm  opacity-7"
                    style={{
                      color: "black",
                      fontWeight: userManagementClick ? "bold" : "normal",
                    }}
                  >
                    {"User Management"}
                  </h6>
                </div>
              ) : null}

              {/*  trailer management : user_id:5 */}
              {loginResponse &&
              ((loginResponse?.user?.userRoles[0]?.user_role_name ==
                CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
                loginResponse?.user?.userRoles[0]?.priority) ||
                (loginResponse?.user?.userRoles[0]?.user_role_name ==
                  CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                  loginResponse?.user?.userRoles[0]?.priority) ||
                (loginResponse?.user?.userRoles[0]?.user_role_name ==
                  CONSTANTS.CONSTANTS_USER_ROLES.VIEWONLY &&
                  loginResponse?.user?.userRoles[0]?.priority)) ? (
                <div
                  className={
                    window.innerWidth < 1200
                      ? "nav-item mt-3 mobileMenu cursor: pointer;"
                      : "d-flex f-direction-row m-2 align-items-center mt-3 cursor: pointer; "
                  }
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "row",
                  }}
                  onClick={() => {
                    isTableLoadClick(false);
                    isMovesClick(false);
                    isTrailersClick(false);
                    isDivisionsClick(false);
                    isCorrectionClick(false);
                    isDoorsClick(false);
                    isLotsClick(false);
                    isOffSiteClick(false);
                    isOffSiteLocationClick(false);
                    isTrailerManagementCompClick(true);
                    isUserManagementClick(false);
                    isRuralHallClick(false);
                    isDriversClick(false);
                    isDepartmentClick(false);
                    setShowSideBar(!showSideBar);
                  }}
                >
                  <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-1 ms-2  d-flex align-items-center justify-content-center">
                    <img src={require("./../assets/Dashboard/truck.png")}></img>
                  </div>
                  <h6
                    className="nav-link-text ms-2 me-4 mt-1 text-uppercase text-sm opacity-7"
                    style={{
                      color: "black",
                      fontWeight: trailerManagementClick ? "bold" : "normal",
                    }}
                  >
                    {"Trailer Management"}
                  </h6>
                </div>
              ) : null}

              <div
                className={
                  window.innerWidth < 1200
                    ? "nav-item mt-3 mobileMenu"
                    : "d-flex f-direction-row m-2 align-items-center mt-3 "
                }
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div
                  className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-1  ms-2 d-flex align-items-center justify-content-center"
                  onClick={() => {
                    localStorage.clear();
                    dispatch({
                      type: CONSTANTS.CONSTANTS_LOGIN.USER_LOGOUT,
                    });
                    dispatch({
                      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_UPDATE_EMAIL,
                      payload: { value: "" },
                    });
                    dispatch({
                      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_UPDATE_PASSWORD,
                      payload: { value: "" },
                    });
                    navigate(-1);
                  }}
                >
                  <img src={require("./../assets/Dashboard/logout1.png")}></img>
                </div>
                <h6
                  onClick={() => {
                    localStorage.clear();
                    dispatch({
                      type: CONSTANTS.CONSTANTS_LOGIN.USER_LOGOUT,
                    });
                    dispatch({
                      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_UPDATE_EMAIL,
                      payload: { value: "" },
                    });
                    dispatch({
                      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_UPDATE_PASSWORD,
                      payload: { value: "" },
                    });
                    navigate(-1);
                  }}
                  className="nav-link-text ms-2 me-4 mt-1 text-uppercase text-sm   opacity-7"
                  style={{ color: "black" }}
                >
                  LogOut
                </h6>
              </div>
            </div>
          </aside>

          <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
            <nav
              className="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl"
              id="navbarBlur"
              navbar-scroll="true"
            >
              <div className="container-fluid py-1 px-3">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
                    <li
                      className="breadcrumb-item text-sm text-dark active"
                      aria-current="page"
                    >
                      {ruralHallClick
                        ? `Rural Hall ${division} DC`
                        : trailerManagementClick
                        ? "Trailer Management"
                        : userManagementClick
                        ? "User Management"
                        : notificationClick
                        ? "Notification"
                        : truck
                        ? "Truck"
                        : tableLoad
                        ? "Reports and Yard check"
                        : ""}
                    </li>
                  </ol>
                  <h6 className="font-weight-bolder mb-0">
                    {moves
                      ? "Yard Moves"
                      : correction
                      ? "Correction"
                      : divisions
                      ? "Divisions"
                      : doors
                      ? "Doors"
                      : drivers
                      ? "Drivers"
                      : lots
                      ? "Yard"
                      : offSite
                      ? "Offsite Moves"
                      : offSiteLocations
                      ? "Off Site Locations"
                      : trailers
                      ? "Trailer Inventory"
                      : trailerManagementClick
                      ? "Trailer Management"
                      : userManagementClick
                      ? "User Management"
                      : department
                      ? "Department"
                      : notificationClick
                      ? "Notification"
                      : truck
                      ? "Truck"
                      : tableLoad
                      ? "Reports and Yard check"
                      : ""}
                  </h6>
                </nav>

                <div
                  className="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4"
                  id="navbar"
                >
                  <div
                    onClick={() => {
                      isNotificationClick(true);
                      isTableLoadClick(false);
                      isMovesClick(false);
                      isTrailersClick(false);
                      isDivisionsClick(false);
                      isCorrectionClick(false);
                      isDoorsClick(false);
                      isLotsClick(false);
                      isOffSiteClick(false);
                      isOffSiteLocationClick(false);
                      isTrailerManagementCompClick(false);
                      isUserManagementClick(false);
                      isRuralHallClick(false);
                      isDriversClick(false);
                      isDepartmentClick(false);
                      isTruckClick(false);
                    }}
                    className="ms-md-auto pe-md-3 d-flex align-items-center"
                  >
                    <img
                      src={require("../assets/Dashboard/notification.png")}
                      style={{ height: "50%", width: "30%" }}
                      className="avatar avatar-sm me-3 "
                    />
                    <div
                      style={{
                        position: "absolute",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        alignContent: "center",
                        width: 22,
                        height: 22,
                        borderRadius: 40,
                        backgroundColor: "red",
                        zIndex: 999,
                        right: "4%",
                        top: "10%",
                      }}
                    >
                      <label
                        style={{
                          color: "white",
                          fontSize: 14,
                          textAlign: "center",
                          margin: 2,
                        }}
                      >
                        {" "}
                        {notifactionCount}
                      </label>
                    </div>
                  </div>

                  <ul className="navbar-nav  justify-content-start">
                    <li className="nav-item d-xl-none ps-3 d-flex align-items-center">
                      <a
                        href="javascript:;"
                        onClick={() => setShowSideBar(!showSideBar)}
                        className="nav-link text-body p-0"
                        id="iconNavbarSidenav"
                      >
                        <div className="sidenav-toggler-inner">
                          <i className="sidenav-toggler-line"></i>
                          <i className="sidenav-toggler-line"></i>
                          <i className="sidenav-toggler-line"></i>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
            {/* <!-- End Navbar --> */}
            {tableLoad ? (
              <div className="container-fluid py-4">
                <BootstrapTableComp />
              </div>
            ) : moves ? (
              <div className="container-fluid py-4">
                <MovesComp />
              </div>
            ) : correction ? (
              <div className="container-fluid py-4">
                <CorrectionComp />
              </div>
            ) : trailers ? (
              <div className="container-fluid py-4">
                <TrailersComp />
              </div>
            ) : divisions ? (
              <div className="container-fluid py-4">
                <DivisionsComp />
              </div>
            ) : doors ? (
              <div className="container-fluid py-4">
                <DoorsComp />
              </div>
            ) : lots ? (
              <div className="container-fluid py-4">
                <LotsComp />
              </div>
            ) : drivers ? (
              <div className="container-fluid py-4">
                <DriversComp />
              </div>
            ) : offSite ? (
              <div className="container-fluid py-4">
                <OffSiteComp />
              </div>
            ) : offSiteLocations ? (
              <div className="container-fluid py-4">
                <OffSiteLocaComp />
              </div>
            ) : userManagementClick ? (
              <div className="container-fluid py-4">
                <UserManagementComp />
              </div>
            ) : trailerManagementClick ? (
              <div className="container-fluid py-4">
                <TrailerManagementComp />
              </div>
            ) : department ? (
              <div className="container-fluid py-4">
                <DepartmentComp />
              </div>
            ) : notificationClick ? (
              <div className="container-fluid py-4">
                <Notification />
              </div>
            ) : truck ? (
              <div className="container-fluid py-4">
                <TruckComp />
              </div>
            ) : null}
          </main>
        </div>
      </div>
    </body>
  );
};
export default Dashboard;
